import Vue from 'vue';
import permission from './permission';

const install = function install() {
  Vue.directive('permission', permission);
};

if (window.Vue) {
  window.permission = permission;
  Vue.use(install); // eslint-disable-line
}

permission.install = install;
export default permission;
